
import React from 'react';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
import { content } from '../data/content';

const Compliance: React.FC = () => {
  const { compliance } = content;

  return (
    <section className="min-h-screen flex items-center justify-center py-20 bg-gray-50/50">
      <div className="container mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-xl shadow-gray-200/50 overflow-hidden border border-gray-100 max-w-5xl mx-auto hover:shadow-2xl transition-shadow duration-500 group">
          <div className="flex flex-col md:flex-row">
            {/* Icon Side */}
            <div className="md:w-1/3 bg-gradient-to-br from-gray-900 to-gray-800 p-10 flex flex-col items-center justify-center text-center relative overflow-hidden">
              <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10"></div>
              <div className="relative z-10">
                <div className="w-24 h-24 bg-white/10 rounded-full flex items-center justify-center mb-6 backdrop-blur-sm border border-white/10 group-hover:scale-110 transition-transform duration-500">
                  <ShieldCheck className="w-12 h-12 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white tracking-tight">{compliance.title}</h3>
                <div className="mt-4 w-12 h-1 bg-red-500 rounded-full"></div>
              </div>
            </div>

            {/* Content Side */}
            <div className="md:w-2/3 p-10 md:p-12 flex flex-col justify-center">
              <h4 className="font-bold text-gray-900 text-xl mb-8 flex items-center">
                <span className="w-1.5 h-8 bg-red-500 rounded-full mr-4"></span>
                {compliance.question}
              </h4>
              <ul className="space-y-6">
                {compliance.items.map((item: any, index: number) => (
                  <li key={index} className="flex items-start group/item">
                    <div className="flex-shrink-0 mt-1 mr-4">
                      <CheckCircle2 className="text-green-500 w-5 h-5 group-hover/item:scale-110 transition-transform" />
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold text-gray-900 text-lg mb-1">{item.title}</span>
                      <span className="text-gray-600 leading-relaxed">{item.text}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Compliance;
